import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { UsersService } from './users.service';
import {
  GET_USERS,
  GET_USERS_STATS,
  UsersAction,
  GetUsersSuccessAction,
  GetUsersFailureAction,
  GetUsersStatsFailureAction,
  GetUsersStatsSuccessAction,
  GET_CURRENT_USER,
  GetCurrentUserSuccessAction,
  GetCurrentUserFailureAction
} from './users.action';

@Injectable()
export class UsersEffects {
  @Effect()
  getUsers$: Observable<UsersAction> = this.actions$.pipe(
    ofType(GET_USERS),
    switchMap(() =>
      this.usersService.users().pipe(
        map((response: any[]) => {
          const users = response.map((user, index) => {
            user.uniqueId = index;
            return user;
          });
          return new GetUsersSuccessAction(users);
        }),
        catchError(error => of(new GetUsersFailureAction(error)))
      )
    )
  ); @Effect()
  getCurrentUsers$: Observable<UsersAction> = this.actions$.pipe(
    ofType(GET_CURRENT_USER),
    switchMap(() =>
      this.usersService.getCurrentUser().pipe(
        map((response: any[]) => {
          const users = response.map((user, index) => {
            user.uniqueId = index;
            return user;
          });
          return new GetCurrentUserSuccessAction(users);
        }),
        catchError(error => of(new GetCurrentUserFailureAction(error)))
      )
    )
  );

  @Effect()
  getUsersStats$: Observable<UsersAction> = this.actions$.pipe(
    ofType(GET_USERS_STATS),
    switchMap(() =>
      this.usersService
        .stats()
        .pipe(
          map(response => new GetUsersStatsSuccessAction(response)),
          catchError(error => of(new GetUsersStatsFailureAction(error)))
        )
    )
  );

  constructor(private actions$: Actions, private usersService: UsersService) {}
}
